import { ActionReducerMapBuilder, createAction } from '@reduxjs/toolkit'

import { getTikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/adapter'
import { TikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/interfaces'
import { NAMESPACE } from 'apps/tiktokFollowWelcome/store/constants'
import { TikTokFollowWelcomeTrigger } from 'shared/api/requests/tiktok/schemas'

export const tikTokTriggerUpdated = createAction<TikTokFollowWelcomeTrigger>(
  `${NAMESPACE}/triggerUpdated`,
)

export const tikTokTriggerUpdatedReducer = (
  builder: ActionReducerMapBuilder<TikTokFollowWelcomeState>,
) => {
  builder.addCase(tikTokTriggerUpdated, (state, action) => ({
    ...state,
    ...getTikTokFollowWelcomeState(action.payload),
  }))
}
